/**
 * @type {MFIStoreState}
 */
export default {
  mfis: [],
  current: null,
}
